import ImageService from '../services/image-service';
import { setError } from '.';

export const imageRequested = () => ({ type: 'IMAGE_REQUESTED' });

export const imageLoaded = (img) => ({
  type: 'IMAGE_LOADED',
  payload: img,
});

export const imageError = (err) => ({
  type: 'IMAGE_ERROR',
  payload: err,
});


export const fetchImage = (query) => (dispatch) => {
  dispatch(imageRequested());
  const imageService = new ImageService(query);
  imageService.getLinkToImage()
    .then((data) => {
      const img = new Image();
      img.src = data;
      img.onload = () => {
        dispatch(imageLoaded(data));
      };
    })
    .catch((err) => {
      dispatch(setError(err.message));
    });
};
